<template>
  <div>
    <div>耕地作业中</div>
    <div>农机型号：{{ info.machineType }}</div>
    <div>本次作业时长：{{ info.workTime }}</div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ['info'],
  methods: {

  }
};
</script>
<style lang="less" scoped>

</style>
